// context/AbilityContext.js
import { Ability } from '@casl/ability';
import React from 'react';

export const ability = new Ability([]);
export const AbilityContext = React.createContext(ability);
